import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import { Alert, Modal } from "react-bootstrap";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { addDays } from "date-fns";
import { DateRangePicker } from "react-date-range";
import { useSelector, useDispatch } from "react-redux";
import {
  setDCountryKey,
  setDRegionKey,
  setDSectorKey,
  setDTopicKey,
  setDSourceKey,
  setDStartDateKey,
  setDEndDateKey,
} from "./../../../services";
import {
  setDevOrgFilter,
  setDevOrgData,
  setDevOrgHandler,
  setDevCountryFilter,
  setDevCountryData,
  setDevCountryHandler,
  setDevRegionFilter,
  setDevRegionData,
  setDevRegionHandler,
  setDevSectorData,
  setDevSectorFilter,
  setDevSectorHandler,
  setDevTopicFilter,
  setDevTopicData,
  setDevTopicHandler,
  setDevSearchCountry,
  setDateTriggerDev,
  setDevStartDate,
  setDevEndDate
  
} from "./../devpubsfiltersevices";
import { setQueryFlag } from "../../../filterServices";
import Button from "react-bootstrap/esm/Button";
import DatePicker from "react-date-picker";
import { _countryListUser } from "./../../../../../shared/httpservice/apis";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";

// import DatePicker from "react-multi-date-picker"
import InputIcon from "react-multi-date-picker/components/input_icon";
import Buttons from "react-multi-date-picker/components/button";
import moment from "moment";
import ScrollArea from "react-scrollbar";
import Scrollbar from "react-perfect-scrollbar-z";
function ResultFilter(props) {
  const dispatch = useDispatch();
  const searchTerm = useSelector((state) => state?.results?.search);
  const file =  useSelector((state) => state?.results?.file);
  const dateTrigger = useSelector((state)=>state?.devFilter?.date_var_dev)
  const [initialSearch, setInitialSearch] = useState(searchTerm);
  const [initialFile,setInitialFile] = useState()
  const [dateStart,setDateStart] = useState(null)
  const [dateEnd,setDateEnd] = useState(null)
  const dateStartChange = useSelector((state)=>state?.devFilter?.dev_start_date_handler)
  const dateEndChange = useSelector((state)=>state?.devFilter?.dev_end_date_handler)
  const categoryFlag = useSelector((state)=>state?.filter?.notification_category)
  // console.log(dateEndChange,"end date");
  //  console.log(dateStartChange,"start date");
  // console.log(dateEndChange,"end date");
  const req =
    useSelector(
      (state) => state?.results?.keyword_search_dev?.response?.request?.responseURL
    ) || "";
  const filterService = useSelector((state) => state?.devFilter);
  const homeFlag = useSelector((state)=>state?.filter?.from_home)
  const queryFlag = useSelector((state)=>state?.filter?.query_flag)
  useEffect(() => {
    if (searchTerm !== initialSearch||file!==initialFile) {
      setInitialSearch(searchTerm);
      setInitialFile(file)
      setFilterState(true);
      // dispatch(setDevCountryData([]));
      // dispatch(setDevOrgData([]));
      // dispatch(setDevCountryHandler([]));
      // dispatch(setDevOrgHandler([]));
      // dispatch(setDevRegionData([]));
      // dispatch(setDevRegionHandler([]));
      // dispatch(setDevSectorHandler([]));
      // dispatch(setDevSectorData([]));
      // dispatch(setDevTopicData([]));
      // dispatch(setDevTopicHandler([]));
      // setOrgChecked(new Array(filters?.org_name?.length).fill(false));
      // setCountryChecked(new Array(filters?.country?.length).fill(false));
      // setRegionChecked(new Array(filters?.region?.length).fill(false));
      // setSectorChecked(new Array(filters?.sector?.length).fill(false));
      // setTopicChecked(new Array(filters?.topic?.length).fill(false));
    }
  }, [searchTerm,file]);
 
  const loading = useSelector(
    (state) => state?.results?.keyword_search_dev?.loading
  );
  const [value, onChange] = useState();
  const facetsStartDate = useSelector(
    (state) =>
      state?.results?.keyword_search_dev?.response?.data?.data?.facets?.start_date
  );
  const ssdate = moment(facetsStartDate);
  const sdate = moment(facetsStartDate);
 // console.log(sdate, "start");
 const [initialDate,setInitialDate] = useState(null)
//  console.log(initialDate);
  useEffect(()=>{
    if(facetsStartDate&&dateTrigger){
      setInitialDate(new Date(moment(facetsStartDate)._d))
      dispatch(setDateTriggerDev(false))
    }
  },[facetsStartDate])
  useEffect(()=>{
    if(facetsStartDate){
      setInitialDate(new Date(moment(facetsStartDate)._d))
    }
},[])
  const [startDate, setStartDate] = useState();
  useEffect(() => {
    if(filterState){
      setStartDate(new Date(moment(facetsStartDate)._d));
    }
    }, [facetsStartDate]);
    useEffect(()=>{
      if(dateStart!==null){
        dispatch(setDevStartDate(dateStart))
      }
      // else{
      //   dispatch(setDevStartDate(null))
      // }
     },[dateStart])
     useEffect(()=>{
      if(dateEnd!==null){
        dispatch(setDevEndDate(dateEnd))
      }
      // else{
      //   dispatch(setDevEndDate(null))
      // }
     },[dateEnd])
    useEffect(()=>{
      if(dateStartChange!==null){
        setStartDate(dateStartChange)
      }
    },[dateStartChange])
    useEffect(()=>{
      if(dateEndChange!==null){
        setEndDate(dateEndChange)
      }
    },[dateEndChange])
//  console.log(startDate, "startdate eval");
  const [endDate, setEndDate] = useState(new Date());
 // console.log(endDate, "end date");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const filters = useSelector(
    (state) => state?.results?.keyword_search_dev?.response?.data?.data?.facets
  );
  const [sDateKey, setSDateKey] = useState("");
 // console.log(sDateKey, "initial");

  const [eDateKey, setEDateKey] = useState("");
 // console.log(eDateKey, "final");
  const startType = startDate?.month?.number;
 
  useEffect(() => {
    if(dateEndChange!==null&&dateEnd!==null){
      if (dateEndChange?.calendar === undefined) {
        setEDateKey(
          dateEndChange?.getFullYear() +
            "-" +
            (dateEndChange?.getMonth() + 1) +
            "-" +
            dateEndChange?.getDate(),
          "finaldate"
        );
      } else {
        setEDateKey(
          dateEndChange?.year + "-" + dateEndChange?.month?.number + "-" + dateEndChange?.day
        );
      }
    }
    
  }, [dateEndChange]);

  const [dateError, setDateError] = useState();

  useEffect(() => {
    if (sDateKey && eDateKey) {
      const x = new Date(sDateKey);
      const y = new Date(eDateKey);
      if (x > y) {
        setDateError("*start date is greater than end date");
      } else {
        setDateError();
      }
    }
  }, [sDateKey, eDateKey]);

  useEffect(() => {
    if(dateStartChange!==null&&dateStart!==null){
      if (dateStartChange?.calendar === undefined) {
        setSDateKey(
          dateStartChange?.getFullYear() +
            "-" +
            (dateStartChange?.getMonth() + 1) +
            "-" +
            dateStartChange?.getDate(),
          "initaildate"
        );
      } else {
        setSDateKey(
          dateStartChange?.year + "-" + dateStartChange?.month?.number + "-" + dateStartChange?.day
        );
      }
    }
   
  }, [dateStartChange]);
  // const [country, setCountry] = useState([])
  // console.log(country);
  // useEffect(() => {
  //     if (filters) setCountry(filters?.country)
  // }, [filters])

  // const [cfilter, setCFilter] = useState([])
  // console.log(cfilter);
  // const [countries,setCountries] = useState("")
  // useEffect(()=>{
  //     var countries = cfilter.join("^")
  //     setCountries(countries)
  // })

  // const onChangeValue = (e) => {
  //     var value = e.target.value
  //     console.log(value);
  //     setCFilter(cfilter => cfilter.includes(value) ? cfilter.filter(u => u !== value) : [...cfilter, value])
  // }
  const [filterState, setFilterState] = useState(true);
 // console.log(filterState, "filter state");
  const [fil, setFil] = useState([]);
 // console.log(fil);
  useEffect(() => {
    if (filters && filterState) setFil(filters);
  }, [filters]);
  //dynamic country filter
  const [country, setCountry] = useState([]);
  //console.log(country, "countries in filter");
  const [uniqueCountry, setUniqueCountry] = useState([]);
  //console.log(uniqueCountry, "country mapped unique");
  useEffect(() => {
    let uniqueChars = country?.filter((c, index) => {
      return country.indexOf(c) === index;
    });
    //console.log(uniqueChars, "unique country array");
    setUniqueCountry(uniqueChars);
  }, [filters, country]);
  useEffect(() => {
    if (
      (filters && filterService?.dev_country_data?.length === 0) ||
      searchTerm !== initialSearch||file!==initialFile
    ) {
      setCountry(fil?.country);
    } else if (filterService?.dev_country_data?.length > 0) {
      setCountry(filterService?.dev_country_data);
      setCFilter(filterService?.dev_country_handler);
    }
  }, [fil]);

  const [cfilter, setCFilter] = useState([]);
  // console.log(cfilter, "filters countries ");
  const [countries, setCountries] = useState("");
  useEffect(() => {
    var countries = cfilter?.join("^");
    setCountries(countries);
  });

  const onChangeValue = (e) => {
    var value = e.target.value;
    //console.log(value);
    setCFilter((cfilter) =>
      cfilter?.includes(value)
        ? cfilter?.filter((u) => u !== value)
        : [...cfilter, value]
    );
    var index = e.target.index;
  };

 
  //dynamic org filter

  const [org, setOrg] = useState([]);
  const [uniqueOrg, setUniqueOrg] = useState([]);
  //console.log(uniqueOrg, "country mapped unique");
  useEffect(() => {
    let uniqueChars = org?.filter((c, index) => {
      return org.indexOf(c) === index;
    });
    //console.log(uniqueChars, "unique country array");
    setUniqueOrg(uniqueChars);
  }, [filters, org]);
  useEffect(() => {
    if (
      (filters && filterService?.dev_org_data?.length === 0) ||
      searchTerm !== initialSearch||file!==initialFile
    ) {
      setOrg(fil?.org_name);
    } else if (filterService?.dev_org_data?.length > 0) {
      setOrg(filterService?.dev_org_data);
      setOrgFilter(filterService?.dev_org_handler);
    }
  }, [fil]);
  const [orgFilter, setOrgFilter] = useState([]);
  //console.log(orgFilter);
  const [orgs, setOrgs] = useState("");
  useEffect(() => {
    var orgs = orgFilter?.join("^");
    setOrgs(orgs);
  });

  //console.log(orgs, "organisation filter");

  const onChangeOrg = (e) => {
    var value = e.target.value;
    setOrgFilter((orgFilter) =>
      orgFilter.includes(value)
        ? orgFilter.filter((u) => u !== value)
        : [...orgFilter, value]
    );
  };

  //dynamic region filter
  const [region, setRegion] = useState([]);
  const [uniqueRegion, setUniqueRegion] = useState([]);
  //console.log(uniqueRegion, "region mapped unique");
  useEffect(() => {
    let uniqueChars = region?.filter((c, index) => {
      return region.indexOf(c) === index;
    });
    //console.log(uniqueChars, "unique region array");
    setUniqueRegion(uniqueChars);
  }, [filters, region]);
  useEffect(() => {
    if (
      (filters && filterService?.dev_region_data?.length === 0) ||
      searchTerm !== initialSearch||file!==initialFile
    ) {
      setRegion(fil?.region);
    } else if (filterService?.dev_region_data?.length > 0) {
      setRegion(filterService?.dev_region_data);
      setRegionFilter(filterService?.dev_region_handler);
    }
  }, [fil]);

  const [regionFilter, setRegionFilter] = useState([]);
  // console.log(regionFilter);
  const [regions, setRegions] = useState("");
  useEffect(() => {
    var regions = regionFilter.join("^");
    setRegions(regions);
  });

  // console.log(filterService?.dev_region_handler,"test");

  const onChangeRegion = (e) => {
    var value = e.target.value;
    setRegionFilter((regionFilter) =>
      regionFilter.includes(value)
        ? regionFilter.filter((u) => u !== value)
        : [...regionFilter, value]
    );
  };
  //dynamic sector filter
  const [sector, setSector] = useState([]);
  const [uniqueSector, setUniqueSector] = useState([]);
  //console.log(uniqueSector, "region mapped unique");
  useEffect(() => {
    let uniqueChars = sector?.filter((c, index) => {
      return sector.indexOf(c) === index;
    });
    //console.log(uniqueChars, "unique region array");
    setUniqueSector(uniqueChars);
  }, [filters, sector]);
  useEffect(() => {
    if (
      (filters && filterService?.dev_sector_data?.length === 0) ||
      searchTerm !== initialSearch||file!==initialFile
    ) {
      setSector(fil?.sector);
    } else if (filterService?.dev_sector_data?.length > 0) {
      setSector(filterService?.dev_sector_data);
      setSectorFilter(filterService?.dev_sector_handler);
    }
  }, [fil]);
  const [sectorFilter, setSectorFilter] = useState([]);
  const [sectors, setSectors] = useState("");
  useEffect(() => {
    var sectors = sectorFilter.join("^");
    setSectors(sectors);
  });

  //console.log(sectors);
  const onChangeSector = (e) => {
    var value = e.target.value;
    setSectorFilter((sectorFilter) =>
      sectorFilter.includes(value)
        ? sectorFilter.filter((u) => u !== value)
        : [...sectorFilter, value]
    );
  };

  //dynamic topic filter
  const [topic, setTopic] = useState([]);
  const [uniqueTopic, setUniqueTopic] = useState([]);
  //console.log(uniqueTopic, "topic mapped unique");
  useEffect(() => {
    let uniqueChars = topic?.filter((c, index) => {
      return topic.indexOf(c) === index;
    });
    //console.log(uniqueChars, "unique region array");
    setUniqueTopic(uniqueChars);
  }, [filters, topic]);
  useEffect(() => {
    if (
      (filters && filterService?.dev_topic_data?.length === 0) ||
      searchTerm !== initialSearch||file!==initialFile
    ) {
      setTopic(fil?.topic);
    } else if (filterService?.dev_topic_data?.length > 0) {
      setTopic(filterService?.dev_topic_data);
      setTopicFilter(filterService?.dev_topic_handler);
    }
  }, [fil]);
  const [topicFilter, setTopicFilter] = useState([]);
  const [topics, setTopics] = useState("");
  useEffect(() => {
    var topics = topicFilter.join("^");
    setTopics(topics);
  });
  //console.log(topics);
  //console.log(topicFilter);
  const onChangeTopic = (e) => {
    var value = e.target.value;
    setTopicFilter((topicFilter) =>
      topicFilter.includes(value)
        ? topicFilter.filter((u) => u !== value)
        : [...topicFilter, value]
    );
  };

  //additional filters
  //country
  useEffect(() => {
    if (fil && filters && req.includes("dev")&&addCountryState===true) {
      //console.log(country, "countries static");
      const notPresent = (filters?.country).filter(
        (val) => !uniqueCountry?.includes(val)
      );

      //console.log(notPresent, "not present in fil");
      if (notPresent?.length > 0 && country?.length > 0) {
        if (notPresent?.length > 0) {
          setCountry(country?.concat(notPresent))
          setUniqueCountry(uniqueCountry?.concat(notPresent))
          for (var i = 0; i < notPresent?.length; i++) {
            //console.log(notPresent[i], "not present in fil");
            // setCountry([...country, notPresent[i]]);
            // if(uniqueCountry!==undefined){
            //   setUniqueCountry([...uniqueCountry, notPresent[i]]);
            // }
            countryChecked?.push(false);
          }
        }
      }
    }
  }, [filters]);
  //org
  useEffect(() => {
    if (fil && filters && req.includes("dev")) {
      //console.log(org, "countries static");
      const notPresent = (filters?.org_name).filter(
        (val) => !uniqueOrg?.includes(val)
      );

      //console.log(notPresent, "not present in fil");
      if (notPresent?.length > 0 && org?.length > 0) {
        if (notPresent?.length > 0) {
          for (var i = 0; i < notPresent?.length; i++) {
            //console.log(notPresent[i], "not present in fil");
            setOrg([...org, notPresent[i]]);
            if(uniqueOrg!==undefined){
              setUniqueOrg([...uniqueOrg, notPresent[i]]);
            }
            
            orgChecked?.push(false);
          }
        }
      }
    }
  }, [filters]);
  //region
  useEffect(() => {
    if (fil && filters && req.includes("dev")) {
      //console.log(region, "countries static");
      const notPresent = (filters?.region).filter(
        (val) => !uniqueRegion?.includes(val)
      );

      //console.log(notPresent, "not present in fil");
      if (notPresent?.length > 0 && region?.length > 0) {
        if (notPresent?.length > 0) {
          for (var i = 0; i < notPresent?.length; i++) {
            //console.log(notPresent[i], "not present in fil");
            setRegion([...region, notPresent[i]]);
            if(uniqueRegion!==undefined){
              setUniqueRegion([...uniqueRegion, notPresent[i]]);
            }
            
            regionChecked?.push(false);
          }
        }
      }
    }
  }, [filters]);

  //sector
  useEffect(() => {
    if (fil && filters && req.includes("dev")) {
      //console.log(sector, "sector static");
      const notPresent = (filters?.sector).filter(
        (val) => !uniqueSector?.includes(val)
      );

      //console.log(notPresent, "not present in fil");
      if (notPresent?.length > 0 && sector?.length > 0) {
        if (notPresent?.length > 0) {
          for (var i = 0; i < notPresent?.length; i++) {
            //console.log(notPresent[i], "not present in fil");
            setSector([...sector, notPresent[i]]);
            if(uniqueSector!==undefined){
              setUniqueSector([...uniqueSector, notPresent[i]]);
            }
            
            sectorChecked?.push(false);
          }
        }
      }
    }
  }, [filters]);
  //topic
  useEffect(() => {
    if (fil && filters && req.includes("dev")) {
      //console.log(topic, "topic static");
      const notPresent = (filters?.topic).filter(
        (val) => !uniqueTopic?.includes(val)
      );

      //console.log(notPresent, "not present in fil");
      if (notPresent?.length > 0 && topic?.length > 0) {
        if (notPresent?.length > 0) {
          for (var i = 0; i < notPresent?.length; i++) {
            //console.log(notPresent[i], "not present in fil");
            setTopic([...topic, notPresent[i]]);
            if(uniqueTopic!==undefined){
              setUniqueTopic([...uniqueTopic, notPresent[i]]);
            }
            
            topicChecked?.push(false);
          }
        }
      }
    }
  }, [filters]);
  const [addCountryState,setAddCountryState] = useState(true)
  const applyfilters = () => {
    if (!dateError) {
      dispatch(setDSourceKey(orgs || ""));
      // dispatch(setDCountryKey(countries || ""));
      if(countries?.length>0&&ecountries?.length===0){
        dispatch(setDCountryKey(countries || ""));
      }else if(countries?.length===0&&ecountries?.length>0){
        dispatch(setDCountryKey(ecountries || ""));
      }else if(countries?.length>0&&ecountries?.length>0){
        const concated = countries.concat("^", ecountries)
        dispatch(setDCountryKey(concated || ""));
      } else if(countries?.length===0&&ecountries?.length===0){
        dispatch(setDCountryKey(""))
      }
      dispatch(setDRegionKey(regions || ""));
      dispatch(setDTopicKey(topics || ""));
      dispatch(setDSectorKey(sectors || ""));
      // if(facetsStartDate!==undefined){
      //   dispatch(setDStartDateKey(sDateKey) || "");
      //   dispatch(setDEndDateKey(eDateKey) || "");
      // }else {
      //   dispatch(setDStartDateKey(""));
      //   dispatch(setDEndDateKey(""));
      // }
      if(dateStartChange!==null){
        dispatch(setDStartDateKey(sDateKey) || "");
      }else {
        dispatch(setDStartDateKey(""));
      }
      if(dateEndChange!==null){
        dispatch(setDEndDateKey(eDateKey) || "");
      }else {
        dispatch(setDEndDateKey(""));
      }
      
    }
    dispatch(setDevOrgFilter(orgChecked));
    dispatch(setDevOrgData(org));
    dispatch(setDevOrgHandler(orgFilter));
    dispatch(setDevCountryFilter(countryChecked));
    dispatch(setDevCountryData(country));
    dispatch(setDevCountryHandler(cfilter));
    dispatch(setDevRegionFilter(regionChecked));
    dispatch(setDevRegionData(uniqueRegion));
    dispatch(setDevRegionHandler(regionFilter));
    dispatch(setDevSectorFilter(sectorChecked));
    dispatch(setDevSectorData(uniqueSector));
    dispatch(setDevSectorHandler(sectorFilter));
    dispatch(setDevTopicFilter(topicChecked));
    dispatch(setDevTopicData(uniqueTopic));
    dispatch(setDevTopicHandler(topicFilter));
    dispatch(setDevSearchCountry(countrySelect));
  };

  useEffect(() => {
    if (searchTerm !== initialSearch||file!==initialFile) {
      setOrgFilter([]);
      setCFilter([]);
      setRegionFilter([]);
      setSectorFilter([]);
      setTopicFilter([]);
      setOrgChecked(new Array(filters?.org_name?.length).fill(false));
      setCountryChecked(new Array(filters?.country?.length).fill(false));
      setRegionChecked(new Array(filters?.region?.length).fill(false));
      setSectorChecked(new Array(filters?.sector?.length).fill(false));
      setTopicChecked(new Array(filters?.topic?.length).fill(false));
    }
  }, [searchTerm,file]);

  const [clear, setClear] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setClear(false);
    });
  }, [clear]);

  const clearFilter = () => {
    dispatch(setDSourceKey(""));
    dispatch(setDCountryKey(""));
    dispatch(setDRegionKey(""));
    dispatch(setDTopicKey(""));
    dispatch(setDSectorKey(""));
    dispatch(setDStartDateKey(""));
    dispatch(setDEndDateKey(""));
    dispatch(setDateTriggerDev(true))
    dispatch(setDevStartDate(null))
    setDateStart(null)
    dispatch(setDevEndDate(null))
    setDateEnd(null)
    setEndDate(new Date())
    setClear(true);
    setOrgFilter([]);
    setCFilter([]);
    setRegionFilter([]);
    setSectorFilter([]);
    setTopicFilter([]);
    setOrgChecked(new Array(uniqueOrg?.length).fill(false));
    setCountryChecked(new Array(uniqueCountry?.length).fill(false));
    let uniqueChars = country.filter((c, index) => {
      return country.indexOf(c) === index;
    });
    setCountry(uniqueChars);
    dispatch(setDevCountryFilter([]));
    dispatch(setDevCountryData([]));
    dispatch(setDevCountryHandler([]));
    let uniqueOChars = org.filter((c, index) => {
      return org.indexOf(c) === index;
    });
    setOrg(uniqueOChars);
    dispatch(setDevOrgFilter([]));
    dispatch(setDevOrgData([]));
    dispatch(setDevOrgHandler([]));
    setRegionChecked(new Array(uniqueRegion?.length).fill(false));
    let uniqueRChars = region.filter((c, index) => {
      return region.indexOf(c) === index;
    });
    setRegion(uniqueRChars);
    dispatch(setDevRegionFilter([]));
    dispatch(setDevRegionData([]));
    dispatch(setDevRegionHandler([]));
    setSectorChecked(new Array(uniqueSector?.length).fill(false));
    let uniqueSChars = sector.filter((c, index) => {
      return sector.indexOf(c) === index;
    });
    setSector(uniqueSChars);
    dispatch(setDevSectorFilter([]));
    dispatch(setDevSectorData([]));
    dispatch(setDevSectorHandler([]));
    setTopicChecked(new Array(uniqueTopic?.length).fill(false));
    let uniqueTChars = topic.filter((c, index) => {
      return topic.indexOf(c) === index;
    });
    setTopic(uniqueTChars);
    dispatch(setDevTopicFilter([]));
    dispatch(setDevTopicData([]));
    dispatch(setDevTopicHandler([]));
    dispatch(setDevSearchCountry([]));
  };

  const Fixeddiv = useRef();
  useLayoutEffect(() => {
    const divAnimate = Fixeddiv.current.getBoundingClientRect().top - 100;
    const onScroll = () => {
      if (divAnimate < window.scrollY) {
        Fixeddiv.current.style.position = "sticky";
        Fixeddiv.current.style.top = "80px";
        Fixeddiv.current.style.left = 0;
      } else {
        Fixeddiv.current.style.position = "inherit";
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  function CustomMultipleInput({ openCalendar, value }) {
    return (
      <div>
        <input onFocus={openCalendar} value={value} readOnly />
      </div>
    );
  }
  const [isFiltActive, setFiltActive] = useState("false");
  const FiltToggleClass = () => {
    setFiltActive(!isFiltActive);
  };

  const states = useSelector((state) => state?.results?.financeCountry);
  const results_state = useSelector((state) => state?.results);
  //org checkbox
  const [orgChecked, setOrgChecked] = useState([]);
  //console.log(orgChecked, "org checkbox");
  const [orgCount,setOrgCount] = useState(0)
  useEffect(()=>{
    if(orgChecked?.length>0){
      const orgCount = orgChecked?.filter(Boolean)?.length
      setOrgCount(orgCount)
    }
  },[orgChecked])
  useEffect(() => {
    if (
      filterService?.dev_org_filter === "" ||
      filterService?.dev_org_filter?.length === 0
    ) {
      setOrgChecked(new Array(filters?.org_name?.length).fill(false));
    }
  }, [fil?.org_name]);

  const handleOnChange = (position) => {
    const updatedCheckedState = orgChecked.map((item, index) =>
      index === position ? !item : item
    );
    setOrgChecked(updatedCheckedState);
  };
  useEffect(() => {
    if (results_state?.evalOrg !== "" && searchTerm === initialSearch) {
      setOrgChecked(filterService?.dev_org_filter);
      //   setOrgFilter([results_state?.financeOrg])
    }
  }, []);
  //country checkbox
  const [countryChecked, setCountryChecked] = useState([]);
  //console.log(countryChecked, "country checkbox");
  const [countryCount,setCountryCount] = useState(0)
  useEffect(()=>{
    if(countryChecked?.length>0){
      const countryCount = countryChecked?.filter(Boolean)?.length
      setCountryCount(countryCount)
    }
  },[countryChecked])
  useEffect(() => {
    if (
      filterService?.dev_country_filter === "" ||
      filterService?.dev_country_filter?.length === 0
    ) {
      setCountryChecked(new Array(filters?.country?.length).fill(false));
    }
  }, [fil?.country]);

  const handleOnChangeCountry = (position) => {
    const updatedCheckedState = countryChecked.map((item, index) =>
      index === position ? !item : item
    );
    setCountryChecked(updatedCheckedState);
  };

  useEffect(() => {
    if (
      filterService?.dev_country_filter?.length > 0 &&
      searchTerm === initialSearch
    ) {
      setCountryChecked(filterService?.dev_country_filter);
      // setCFilter([results_state?.financeCountry])
    }
  }, []);
   //aditional countries

   const [addCountries, setAddCountries] = useState([]);
   // console.log(addCountries,"search countries");
   const [searchCountries,setSearchCountries] = useState([])
   const listCountry = async () => {
     const response = await _countryListUser();
    // console.log(response);
     setAddCountries(response?.data?.data?.element);
   };
   useEffect(()=>{
     if(country?.length>0){
       const searchCountries = country?.map((item)=>{
         return {code : item, label : item}
       })
       
       const label = country?.map((item)=>({name:item}))
       const myArray = addCountries.filter(ar => !label.find(rm => (rm.name === ar.name) ))
       setSearchCountries(myArray)
     }
   },[country,addCountries])
   const Option = (props) => {
     return (
       <div>
         <components.Option {...props}>
           <input
             className="react-multi-select-item"
             type="checkbox"
             checked={props.isSelected}
             onChange={() => null}
           />{" "}
           <label>{props.label}</label>
         </components.Option>
       </div>
     );
   };
   useEffect(() => {
     listCountry();
   }, []);
   const cou = searchCountries.map((item) => ({
     value: item.code,
     label: item.name,
   }));
   const [countrySelect, setCountrySelect] = useState([]);
 
   const newMulcou = countrySelect?.map((item) => ({ value: item.label }));
   var countryValues = newMulcou.map((i) => {
     return i.value;
   });
 
   const [ecountries, setECountries] = useState("");
   useEffect(() => {
     var countries = countryValues?.join("^");
     setECountries(countries);
   });
 
   const initialCountry = useSelector(
    (state) => state?.devFilter?.dev_search_country_array
   );
   useEffect(() => {
     if (initialCountry) {
       setCountrySelect(initialCountry);
     }
   }, [initialCountry]);
 
   useEffect(()=>{
     if(ecountries?.length>0){
      //  console.log("greater than one");
       setAddCountryState(false)
     }else if (ecountries?.length===0){
       setAddCountryState(true)
     }
   },[ecountries])
  //region checkbox
  const [regionChecked, setRegionChecked] = useState([]);
  //console.log(regionChecked, "region checkbox");
  const [regionCount,setRegionCount] = useState(0)
  useEffect(()=>{
    if(regionChecked?.length>0){
      const regionCount = regionChecked?.filter(Boolean)?.length
      setRegionCount(regionCount)
    }
  },[regionChecked])
  useEffect(() => {
    if (
      filterService?.dev_region_filter === "" ||
      filterService?.dev_region_filter?.length === 0
    ) {
      setRegionChecked(new Array(filters?.region?.length).fill(false));
    }
  }, [fil?.region]);

  const handleOnChangeRegion = (position) => {
    const updatedCheckedState = regionChecked.map((item, index) =>
      index === position ? !item : item
    );
    setRegionChecked(updatedCheckedState);
  };
  useEffect(() => {
    if (results_state?.regionOrg !== "" && searchTerm === initialSearch) {
      setRegionChecked(filterService?.dev_region_filter);
      //   setOrgFilter([results_state?.financeOrg])
    }
  }, []);

  //sector checkbox
  const [sectorChecked, setSectorChecked] = useState([]);
  //console.log(sectorChecked, "sector checkbox");
  const [sectorCount,setSectorCount] = useState(0)
  useEffect(()=>{
    if(sectorChecked?.length>0){
      const sectorCount = sectorChecked?.filter(Boolean)?.length
      setSectorCount(sectorCount)
    }
  },[sectorChecked])
  useEffect(() => {
    if (
      filterService?.dev_sector_filter === "" ||
      filterService?.dev_sector_filter?.length === 0
    ) {
      setSectorChecked(new Array(filters?.sector?.length).fill(false));
    }
  }, [fil?.sector]);

  const handleOnChangeSector = (position) => {
    const updatedCheckedState = sectorChecked.map((item, index) =>
      index === position ? !item : item
    );
    setSectorChecked(updatedCheckedState);
  };
  useEffect(() => {
    if (results_state?.sectorOrg !== "" && searchTerm === initialSearch) {
      setSectorChecked(filterService?.dev_sector_filter);
      //   setOrgFilter([results_state?.financeOrg])
    }
  }, []);

  //topic checkbox
  const [topicChecked, setTopicChecked] = useState([]);
  //console.log(topicChecked, "topic checkbox");
  const [topicCount,setTopicCount] = useState(0)
  
  useEffect(()=>{
    if(topicChecked?.length>0){
      const topicCount = topicChecked?.filter(Boolean)?.length
      setTopicCount(topicCount)
    }
  },[topicChecked])
  useEffect(() => {
    if (
      filterService?.dev_topic_filter === "" ||
      filterService?.dev_topic_filter?.length === 0
    ) {
      setTopicChecked(new Array(filters?.topic?.length).fill(false));
    }
  }, [fil?.region]);

  const handleOnChangeTopic = (position) => {
    const updatedCheckedState = topicChecked.map((item, index) =>
      index === position ? !item : item
    );
    setTopicChecked(updatedCheckedState);
  };
  useEffect(() => {
    if (results_state?.topicOrg !== "" && searchTerm === initialSearch) {
      setTopicChecked(filterService?.dev_topic_filter);
      //   setOrgFilter([results_state?.financeOrg])
    }
  }, []);

  const statess = useSelector((state) => state?.filter);
  const [countryFilterCount,setCountryFilterCount] = useState(0)
  useEffect(()=>{
    setCountryFilterCount(countryCount+countrySelect?.length)
  })

  useEffect(()=>{
    if(categoryFlag!=="devpubs"){
      setOrgCount(0)
      setRegionCount(0)
      setTopicCount(0)
      setCountryCount(0)
      setSectorCount(0)
    }
  },[categoryFlag])

  useEffect(()=>{
    if(queryFlag){
      setOrgChecked(filterService?.dev_org_filter);
      setCountryChecked(filterService?.dev_country_filter);
      setRegionChecked(filterService?.dev_region_filter);
      setSectorChecked(filterService?.dev_sector_filter);
      setTopicChecked(filterService?.dev_topic_filter);
    }
  },[filterService?.dev_org_filter,
    filterService?.dev_country_filter,
    filterService?.dev_region_filter,
    filterService?.dev_sector_filter,
    filterService?.dev_topic_filter,
   ])
  return (
    <div className="main-container" ref={Fixeddiv}>
      <div onClick={FiltToggleClass} className="mobile-fliter-full">
        <h4>Filter</h4>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19.652"
          height="19.653"
          viewBox="0 0 19.652 19.653"
        >
          <path
            class="a"
            d="M19.384,0H1.268A.768.768,0,0,0,.5.768a7.5,7.5,0,0,0,2.514,5.6L6.376,9.355A2.735,2.735,0,0,1,7.294,11.4v7.486a.768.768,0,0,0,1.193.639L13.016,16.5a.768.768,0,0,0,.342-.639V11.4a2.736,2.736,0,0,1,.917-2.043l3.362-2.988a7.5,7.5,0,0,0,2.514-5.6A.768.768,0,0,0,19.384,0ZM16.618,5.219,13.256,8.208a4.272,4.272,0,0,0-1.433,3.19v4.056l-2.994,2V11.4A4.272,4.272,0,0,0,7.4,8.208L4.034,5.219A5.963,5.963,0,0,1,2.085,1.535H18.567a5.962,5.962,0,0,1-1.949,3.684Zm0,0"
            transform="translate(-0.5 0)"
          />
        </svg>
      </div>
      <div className={isFiltActive ? "filter-hidden" : "filter-active"}>
        <div className="result-filter-box">
          <h4>Filters
          <span className="filter-sub-text"> (Number of filters applied)</span>
          </h4>
          <div className="filter-accordian-wrap">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Organisation {orgCount===0?null:"("+orgCount+")"}</Accordion.Header>
                <Accordion.Body>
                <Scrollbar
                    speed={0.8}
                    className="filter-box-scroll"
                    always
                  >
                  {/* <div className="checkbox-box">
                                    {clear||loading && initialSearch!==searchTerm ? null : <>
                                        {org.map((item, i) => (
                                        <div className="checkbox-wrapper" key={i}>
                                            <input type="checkbox" value={item} id={`org${i}`} onClick={onChangeOrg} />
                                            <label htmlFor={`org${i}`} >
                                                <span>{item}</span>
                                            </label>
                                        </div>
                                    ))}
                                    </>}
                                    
                                </div> */}
                  <div className="checkbox-box">
                    {clear ||
                    (loading && initialSearch !== searchTerm) ? null : (
                      <>
                        {uniqueOrg?.map((item, i) => (
                          <div className="checkbox-wrapper" key={i}>
                            <input
                              type="checkbox"
                              value={item}
                              id={`devorg${i}`}
                              onClick={onChangeOrg}
                              checked={orgChecked[i]}
                              onChange={() => {
                                handleOnChange(i);
                              }}
                            />
                            <label htmlFor={`devorg${i}`}>
                              <span>{item}</span>
                            </label>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  </Scrollbar>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Region {regionCount===0?null:"("+regionCount+")"}</Accordion.Header>
                <Accordion.Body>
                <Scrollbar
                    speed={0.8}
                    className="filter-box-scroll"
                    always
                  >
                  {/* <div className="checkbox-box" >
                                    {clear||loading && initialSearch!==searchTerm ? null : <>
                                        {region.map((item, i) => (
                                        <div className="checkbox-wrapper" key={i}>
                                            <input type="checkbox" value={item} id={`region${i}`} onClick={onChangeRegion} />
                                            <label htmlFor={`region${i}`} >
                                                <span>{item}</span>
                                            </label>
                                        </div>
                                    ))}
                                    </>}
                                    
                                </div> */}
                  <div className="checkbox-box">
                    {clear ||
                    (loading && initialSearch !== searchTerm) ? null : (
                      <>
                        {uniqueRegion?.map((item, i) => (
                          <div className="checkbox-wrapper" key={i}>
                            <input
                              type="checkbox"
                              value={item}
                              id={`devregion${i}`}
                              onClick={onChangeRegion}
                              checked={regionChecked[i]}
                              onChange={() => handleOnChangeRegion(i)}
                            />
                            <label htmlFor={`devregion${i}`}>
                              <span>{item}</span>
                            </label>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  </Scrollbar>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Country {countryFilterCount===0?null:"("+countryFilterCount+")"}</Accordion.Header>
                <Accordion.Body>
              
                  {/* <div className="country-filter">
                                    <div className="checkbox-box">
                                        {clear||loading && initialSearch!==searchTerm ? null : <>
                                            {country.map((item, i) => (
                                            <div className="checkbox-wrapper" key={i}>
                                                <input type="checkbox" value={item} id={i} onClick={onChangeValue} />
                                                <label htmlFor={i} >
                                                    <span>{item}</span>
                                                </label>
                                            </div>
                                        ))}
                                        </>}
                                        




                                    </div>
                                </div> */}
                  <div className="country-filter">
                    {/* <Form.Label>Countries<span style={{color:"red"}}>*</span></Form.Label> */}
                    <ReactSelect
                        options={cou}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        allowSelectAll={true}
                        classNamePrefix="react-select-2-option"
                        className="react-multi-select"
                        selected={countrySelect}
                        onChange={setCountrySelect}
                        value={countrySelect}
                        name="countries"
                        blurInputOnSelect={false}
                      />
                     <Scrollbar
                    speed={0.8}
                    className="filter-box-scroll"
                    always
                  >
                    <div className="checkbox-box">
                      {clear ||
                      (loading && initialSearch !== searchTerm) ? null : (
                        <>
                          {uniqueCountry?.map((item, i) => (
                            <div className="checkbox-wrapper" key={i}>
                              <input
                                type="checkbox"
                                value={item}
                                id={`devcountry${i}`}
                                onClick={onChangeValue}
                                checked={countryChecked[i]}
                                onChange={() => {
                                  handleOnChangeCountry(i);
                                }}
                              />
                              <label htmlFor={`devcountry${i}`}>
                                <span>{item}</span>
                              </label>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                    </Scrollbar>
                  </div>
                  
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Sector {sectorCount===0?null:"("+sectorCount+")"}</Accordion.Header>
                <Accordion.Body>
                <Scrollbar
                    speed={0.8}
                    className="filter-box-scroll"
                    always
                  >
                  {/* <div className="checkbox-box">
                                    {clear||loading && initialSearch!==searchTerm ? null : <>
                                        {sector.map((item, i) => (
                                        <div className="checkbox-wrapper" key={i}>
                                            <input type="checkbox" value={item} id={`sector${i}`} onClick={onChangeSector} />
                                            <label htmlFor={`sector${i}`} >
                                                <span>{item}</span>
                                            </label>
                                        </div>
                                    ))}
                                    </>}
                                    
                                </div> */}
                  <div className="checkbox-box">
                    {clear ||
                    (loading && initialSearch !== searchTerm) ? null : (
                      <>
                        {uniqueSector?.map((item, i) => (
                          <div className="checkbox-wrapper" key={i}>
                            <input
                              type="checkbox"
                              value={item}
                              id={`devsector${i}`}
                              onClick={onChangeSector}
                              checked={sectorChecked[i]}
                              onChange={() => {
                                handleOnChangeSector(i);
                              }}
                            />
                            <label htmlFor={`devsector${i}`}>
                              <span>{item}</span>
                            </label>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  </Scrollbar>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Topic {topicCount===0?null:"("+topicCount+")"}</Accordion.Header>
                <Accordion.Body>
                <Scrollbar
                    speed={0.8}
                    className="filter-box-scroll"
                    always
                  >
                  {/* <div className="checkbox-box">
                                    {clear||loading && initialSearch!==searchTerm ? null : <>
                                        {topic.map((item, i) => (
                                        <div className="checkbox-wrapper" key={i}>
                                            <input type="checkbox" value={item} id={`topic${i}`} onClick={onChangeTopic} />
                                            <label htmlFor={`topic${i}`} >
                                                <span>{item}</span>
                                            </label>
                                        </div>
                                    ))}
                                    </>}
                                   
                                </div> */}
                  <div className="checkbox-box">
                    {clear ||
                    (loading && initialSearch !== searchTerm) ? null : (
                      <>
                        {uniqueTopic?.map((item, i) => (
                          <div className="checkbox-wrapper" key={i}>
                            <input
                              type="checkbox"
                              value={item}
                              id={`devtopic${i}`}
                              onClick={onChangeTopic}
                              checked={topicChecked[i]}
                              onChange={() => {
                                handleOnChangeTopic(i);
                              }}
                            />
                            <label htmlFor={`devtopic${i}`}>
                              <span>{item}</span>
                            </label>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  </Scrollbar>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>Date</Accordion.Header>
                <Accordion.Body>
                  <div className="date-calendar-wrap m-b-20">
                    <Form className="w-100 p-relative date-picker-wrap">
                      <div className="form-input-wrap">
                        <Form.Label>Select start date</Form.Label>
                        <div className="custom-date-picker">
                          <DatePicker
                            onChange={setDateStart}
                            value={dateStartChange!==null&&dateStartChange!==""&&dateStartChange!==undefined?new Date(dateStartChange):null}
                            yearPlaceholder="yyyy"
                            monthPlaceholder="mm"
                            dayPlaceholder="dd"
                            calendarAriaLabel="select start date"
                            // minDate={initialDate}
                            // openToDate={initialDate}
                            maxDate={addDays(new Date(), 0)}
                            // selected={startDate}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            clearIcon={null}
                            onFocus={e => e.target.blur()}
                          />
                          <div className="calendar-icon">
                            <svg
                              width="24"
                              height="27"
                              viewBox="0 0 24 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 27C1.46667 27 1 26.7975 0.6 26.3925C0.2 25.9875 0 25.515 0 24.975V4.05C0 3.51 0.2 3.0375 0.6 2.6325C1 2.2275 1.46667 2.025 2 2.025H4.16667V0H6.33333V2.025H17.6667V0H19.8333V2.025H22C22.5333 2.025 23 2.2275 23.4 2.6325C23.8 3.0375 24 3.51 24 4.05V24.975C24 25.515 23.8 25.9875 23.4 26.3925C23 26.7975 22.5333 27 22 27H2ZM2 24.975H22V10.4625H2V24.975ZM2 8.4375H22V4.05H2V8.4375ZM2 8.4375V4.05V8.4375ZM12 16.2C11.6222 16.2 11.3056 16.0706 11.05 15.8119C10.7944 15.5531 10.6667 15.2325 10.6667 14.85C10.6667 14.4675 10.7944 14.1469 11.05 13.8881C11.3056 13.6294 11.6222 13.5 12 13.5C12.3778 13.5 12.6944 13.6294 12.95 13.8881C13.2056 14.1469 13.3333 14.4675 13.3333 14.85C13.3333 15.2325 13.2056 15.5531 12.95 15.8119C12.6944 16.0706 12.3778 16.2 12 16.2ZM6.66667 16.2C6.28889 16.2 5.97222 16.0706 5.71667 15.8119C5.46111 15.5531 5.33333 15.2325 5.33333 14.85C5.33333 14.4675 5.46111 14.1469 5.71667 13.8881C5.97222 13.6294 6.28889 13.5 6.66667 13.5C7.04444 13.5 7.36111 13.6294 7.61667 13.8881C7.87222 14.1469 8 14.4675 8 14.85C8 15.2325 7.87222 15.5531 7.61667 15.8119C7.36111 16.0706 7.04444 16.2 6.66667 16.2ZM17.3333 16.2C16.9556 16.2 16.6389 16.0706 16.3833 15.8119C16.1278 15.5531 16 15.2325 16 14.85C16 14.4675 16.1278 14.1469 16.3833 13.8881C16.6389 13.6294 16.9556 13.5 17.3333 13.5C17.7111 13.5 18.0278 13.6294 18.2833 13.8881C18.5389 14.1469 18.6667 14.4675 18.6667 14.85C18.6667 15.2325 18.5389 15.5531 18.2833 15.8119C18.0278 16.0706 17.7111 16.2 17.3333 16.2ZM12 21.6C11.6222 21.6 11.3056 21.4706 11.05 21.2119C10.7944 20.9531 10.6667 20.6325 10.6667 20.25C10.6667 19.8675 10.7944 19.5469 11.05 19.2881C11.3056 19.0294 11.6222 18.9 12 18.9C12.3778 18.9 12.6944 19.0294 12.95 19.2881C13.2056 19.5469 13.3333 19.8675 13.3333 20.25C13.3333 20.6325 13.2056 20.9531 12.95 21.2119C12.6944 21.4706 12.3778 21.6 12 21.6ZM6.66667 21.6C6.28889 21.6 5.97222 21.4706 5.71667 21.2119C5.46111 20.9531 5.33333 20.6325 5.33333 20.25C5.33333 19.8675 5.46111 19.5469 5.71667 19.2881C5.97222 19.0294 6.28889 18.9 6.66667 18.9C7.04444 18.9 7.36111 19.0294 7.61667 19.2881C7.87222 19.5469 8 19.8675 8 20.25C8 20.6325 7.87222 20.9531 7.61667 21.2119C7.36111 21.4706 7.04444 21.6 6.66667 21.6ZM17.3333 21.6C16.9556 21.6 16.6389 21.4706 16.3833 21.2119C16.1278 20.9531 16 20.6325 16 20.25C16 19.8675 16.1278 19.5469 16.3833 19.2881C16.6389 19.0294 16.9556 18.9 17.3333 18.9C17.7111 18.9 18.0278 19.0294 18.2833 19.2881C18.5389 19.5469 18.6667 19.8675 18.6667 20.25C18.6667 20.6325 18.5389 20.9531 18.2833 21.2119C18.0278 21.4706 17.7111 21.6 17.3333 21.6Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  <div className="date-calendar-wrap">
                    <Form className="w-100 p-relative date-picker-wrap">
                      <div className="form-input-wrap">
                        <Form.Label>Select end date</Form.Label>
                        <div className="custom-date-picker">
                          <DatePicker
                            onChange={setDateEnd}
                            value={dateEndChange!==null&&dateEndChange!==undefined&&dateEndChange!==""?new Date(dateEndChange):null}
                            yearPlaceholder="yyyy"
                            monthPlaceholder="mm"
                            dayPlaceholder="dd"
                            calendarAriaLabel="select start date"
                            // minDate={initialDate}
                            maxDate={addDays(new Date(), 0)}
                            // openToDate={addDays(new Date(), 0)}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            clearIcon={null}
                            onFocus={e => e.target.blur()}
                          />
                          <div className="calendar-icon">
                            <svg
                              width="24"
                              height="27"
                              viewBox="0 0 24 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 27C1.46667 27 1 26.7975 0.6 26.3925C0.2 25.9875 0 25.515 0 24.975V4.05C0 3.51 0.2 3.0375 0.6 2.6325C1 2.2275 1.46667 2.025 2 2.025H4.16667V0H6.33333V2.025H17.6667V0H19.8333V2.025H22C22.5333 2.025 23 2.2275 23.4 2.6325C23.8 3.0375 24 3.51 24 4.05V24.975C24 25.515 23.8 25.9875 23.4 26.3925C23 26.7975 22.5333 27 22 27H2ZM2 24.975H22V10.4625H2V24.975ZM2 8.4375H22V4.05H2V8.4375ZM2 8.4375V4.05V8.4375ZM12 16.2C11.6222 16.2 11.3056 16.0706 11.05 15.8119C10.7944 15.5531 10.6667 15.2325 10.6667 14.85C10.6667 14.4675 10.7944 14.1469 11.05 13.8881C11.3056 13.6294 11.6222 13.5 12 13.5C12.3778 13.5 12.6944 13.6294 12.95 13.8881C13.2056 14.1469 13.3333 14.4675 13.3333 14.85C13.3333 15.2325 13.2056 15.5531 12.95 15.8119C12.6944 16.0706 12.3778 16.2 12 16.2ZM6.66667 16.2C6.28889 16.2 5.97222 16.0706 5.71667 15.8119C5.46111 15.5531 5.33333 15.2325 5.33333 14.85C5.33333 14.4675 5.46111 14.1469 5.71667 13.8881C5.97222 13.6294 6.28889 13.5 6.66667 13.5C7.04444 13.5 7.36111 13.6294 7.61667 13.8881C7.87222 14.1469 8 14.4675 8 14.85C8 15.2325 7.87222 15.5531 7.61667 15.8119C7.36111 16.0706 7.04444 16.2 6.66667 16.2ZM17.3333 16.2C16.9556 16.2 16.6389 16.0706 16.3833 15.8119C16.1278 15.5531 16 15.2325 16 14.85C16 14.4675 16.1278 14.1469 16.3833 13.8881C16.6389 13.6294 16.9556 13.5 17.3333 13.5C17.7111 13.5 18.0278 13.6294 18.2833 13.8881C18.5389 14.1469 18.6667 14.4675 18.6667 14.85C18.6667 15.2325 18.5389 15.5531 18.2833 15.8119C18.0278 16.0706 17.7111 16.2 17.3333 16.2ZM12 21.6C11.6222 21.6 11.3056 21.4706 11.05 21.2119C10.7944 20.9531 10.6667 20.6325 10.6667 20.25C10.6667 19.8675 10.7944 19.5469 11.05 19.2881C11.3056 19.0294 11.6222 18.9 12 18.9C12.3778 18.9 12.6944 19.0294 12.95 19.2881C13.2056 19.5469 13.3333 19.8675 13.3333 20.25C13.3333 20.6325 13.2056 20.9531 12.95 21.2119C12.6944 21.4706 12.3778 21.6 12 21.6ZM6.66667 21.6C6.28889 21.6 5.97222 21.4706 5.71667 21.2119C5.46111 20.9531 5.33333 20.6325 5.33333 20.25C5.33333 19.8675 5.46111 19.5469 5.71667 19.2881C5.97222 19.0294 6.28889 18.9 6.66667 18.9C7.04444 18.9 7.36111 19.0294 7.61667 19.2881C7.87222 19.5469 8 19.8675 8 20.25C8 20.6325 7.87222 20.9531 7.61667 21.2119C7.36111 21.4706 7.04444 21.6 6.66667 21.6ZM17.3333 21.6C16.9556 21.6 16.6389 21.4706 16.3833 21.2119C16.1278 20.9531 16 20.6325 16 20.25C16 19.8675 16.1278 19.5469 16.3833 19.2881C16.6389 19.0294 16.9556 18.9 17.3333 18.9C17.7111 18.9 18.0278 19.0294 18.2833 19.2881C18.5389 19.5469 18.6667 19.8675 18.6667 20.25C18.6667 20.6325 18.5389 20.9531 18.2833 21.2119C18.0278 21.4706 17.7111 21.6 17.3333 21.6Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  {dateError && (
                    <span style={{ color: "red" }}>{dateError}</span>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="filter-button btn-wrap double-btn">
              {dateError ? (
                <Button disabled size="sm" onClick={applyfilters}>
                  Apply Filters
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={() => {
                    setFilterState(false);
                    applyfilters();
                    setFiltActive('false')
                  }}
                >
                  Apply Filters
                </Button>
              )}

              <button
                size="sm"
                className="btn grey-border-btn btn-sm"
                onClick={() => {
                  setFilterState(true);
                  clearFilter();
                  setFiltActive('false')
                }}
              >
                Clear Filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResultFilter;